import { Box } from '@givebutter/primitives/box';
import { Separator } from '@givebutter/primitives/separator';
import { BetaSettings } from 'assets/js/pages/account-settings/account-about/BetaSettings';
import { DeleteOrCloseAccountSettings } from 'assets/js/pages/account-settings/account-about/DeleteOrCloseAccountSettings';
import { GeneralSettings } from 'assets/js/pages/account-settings/account-about/GeneralSettings';
import { SocialSettings } from 'assets/js/pages/account-settings/account-about/SocialSettings';
import { Permission, Permissions } from 'components/permissions';

const AboutSettings = () => {
    return (
        <Box className="flex flex-col gap-8 p-8">
            <GeneralSettings />
            <Separator />

            <SocialSettings />
            <Separator />

            <BetaSettings />

            <Permissions allowed={[Permission.Admin]}>
                <Separator />
                <DeleteOrCloseAccountSettings />
            </Permissions>
        </Box>
    );
};

export { AboutSettings };
